import { render, staticRenderFns } from "./StatisticProjectReportsBlankConfirmTableTotal.vue?vue&type=template&id=7b60f747&"
import script from "./StatisticProjectReportsBlankConfirmTableTotal.vue?vue&type=script&lang=js&"
export * from "./StatisticProjectReportsBlankConfirmTableTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports